<div id="preview" #preview>
  <div *ngIf="isInitializing">Loading preview... Please wait.</div>
  <div class="row justify-content-center height-400" *ngIf="!isVideo">
    <div class="my-auto">
      <div class="circle">
        <span class="initials ">{{initials}}</span>
      </div>
    </div>
  </div>
</div>